<mat-sidenav-container class="white-background h-100">
    <app-menu></app-menu>
</mat-sidenav-container>